export default function fieldHasData(text) {
    return text && text.trim().length > 0;
}
